import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=dd828202&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=dd828202&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./tag.vue?vue&type=style&index=1&id=dd828202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd828202",
  null
  
)

export default component.exports